import { render, staticRenderFns } from "./SelectOpe.vue?vue&type=template&id=38cf8b7a&"
import script from "./SelectOpe.vue?vue&type=script&lang=ts&"
export * from "./SelectOpe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports